export default () => {

    const stickyItem = document.getElementById("js-sticky-item");


    if (stickyItem !== null) {

        const top = stickyItem.getAttribute('data-js-sticky-item-top');

        window.onscroll = function () {
            stickyFunction(top)
        };

        let sticky = stickyItem.offsetTop;

        function stickyFunction(top) {
            if (window.pageYOffset - top >= sticky) {
                stickyItem.classList.add("sticky-item--active")
            } else {
                stickyItem.classList.remove("sticky-item--active");
            }
        }
    }

}

